import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import CSSReset, { GlobalFlexMain } from '@tds/core-css-reset'
import changeLocale from '../../utils/changeLocale'
import './global.scss'

class App extends Component {
  componentDidMount() {
    window.addEventListener('GELocaleChange', event => changeLocale(event))
  }

  render() {
    const { children } = this.props
    return (
      <>
        <CSSReset />
        <GlobalFlexMain />
        {children}
      </>
    )
  }
}

App.propTypes = {
  children: PropTypes.node.isRequired
}

export default (App)
